// A generic table component. It is currently intended for the CMS segment of
// the app, but it won't be difficult to extend its use, if needed.

import type { FunctionComponent, ReactNode } from 'react';

import { Dropdown } from '@dr.pogodin/react-utils';

import Throbber from 'components/Throbber';

import Paginator from './Paginator';

import './style.scss';

// TODO: Move to generic utils?
type OptionalPropsGroup<T> = Partial<Record<keyof T, undefined>> | T;

type PropsT = OptionalPropsGroup<{
  numPages: number;
  page: number;
  setPage: (page: number) => void;
}> & OptionalPropsGroup<{
  pageSize?: number;
  pageSizeOptions?: number[];
  setPageSize?: (size: number) => void;
}> & {
  busy?: boolean;
  children: ReactNode;
};

const Table: FunctionComponent<PropsT> = ({
  busy,
  children,
  numPages,
  page = 0,
  pageSize,
  pageSizeOptions,
  setPage,
  setPageSize,
}) => {
  const footerContent: ReactNode[] = [];

  if (pageSizeOptions) {
    footerContent.push(
      <Dropdown
        key="page-size-selector"
        label="Showing"
        onChange={setPageSize ? (e) => {
          setPageSize(parseInt(e.target.value));
        } : undefined}
        options={pageSizeOptions}
        value={pageSize ?? pageSizeOptions[0]}
      />,
    );
  }

  if (numPages) {
    footerContent.push(
      <Paginator
        key="paginator"
        numPages={numPages}
        selectedPage={page}
        setSelectedPage={setPage}
      />,
    );
  }

  return (
    <div styleName="outerContainer">
      <div styleName="innerContainer">
        <table styleName="table">
          {children}
        </table>
      </div>
      {footerContent.length
        ? <div styleName="footer">{footerContent}</div>
        : null}
      {busy ? <Throbber withDebounce withOverlay /> : null}
    </div>
  );
};

export default Table;
